class AdpButtonController {
  constructor() {
    this.name = 'adpButton';
  }
  action() {
      if(this.url) {
        window.location.href = this.url;
      }
  }
}

export default AdpButtonController;



// WEBPACK FOOTER //
// ./src/app/components/adpButton/adpButton.controller.js